import React from 'react';
import NumberFormat from 'react-number-format';

function NumberFormatDecorator({ value }) {
	return (
		<NumberFormat
			displayType={'text'}
			value={value}
			thousandSeparator={true}
		/>
	);
}

export default NumberFormatDecorator;
